import { create } from 'zustand';
import { IUser, LoginResponse } from './authInterface';


export interface AuthState {
	isLoggedIn: boolean;
	accessToken: string | null;
	user: IUser | null;
}

const initialState: AuthState = {
	isLoggedIn: false,
	accessToken: null,
	user: null,
};

type Actions = {
	storeLogin: (data: LoginResponse) => void;
	logout: ()=>void;
};

export const useAuthStore = create<AuthState & Actions>()((set) => ({
	...initialState,
	storeLogin: (response: LoginResponse) =>
		set((state) => {
			localStorage.setItem('access_token', response.token);

			return {
				isLoggedIn: true,
				accessToken: response.token,
				user: response.user,
			};
		}),

	logout: () => 
		set((state)=>{
			localStorage.clear();
			sessionStorage.clear();
			return {
				isLoggedIn:false,
				accessToken:null,
				user:null
			}
		})
}));
